import * as React from "react";
const SvgFiRrPeach = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-peach_svg__a)">
      <path
        fill="#062147"
        d="M20.6 5.235C22.74 2.682 22.513-.173 18.74 0a7.16 7.16 0 0 0-6.191 3.439A4.66 4.66 0 0 0 8-.001a1 1 0 0 0 0 2c1.915 0 2.605 1.622 2.855 2.8A7.536 7.536 0 0 0 0 11.5C0 19.589 7.927 24 12 24s12-4.411 12-12.5a7.47 7.47 0 0 0-3.4-6.264M18.74 2c.414-.002.828.04 1.233.125-.659 2.694-3.12 4-6.48 3.865A5.57 5.57 0 0 1 18.74 2M12 22C9.01 22 2 18.428 2 11.5c.232-7.268 10.769-7.268 11 0a12.25 12.25 0 0 1-1.833 5.946 1 1 0 1 0 1.665 1.109c.792-.88 3.532-7.093 1.293-10.563a8.9 8.9 0 0 0 4.928-1.35A5.48 5.48 0 0 1 22 11.5C22 18.428 14.99 22 12 22"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-peach_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPeach;
